import { Module, VuexModule, Mutation } from "vuex-module-decorators";
import { Member } from "@/models/Member";

@Module({
  name: "memberModule",
})
export default class MemberModule extends VuexModule {
  public static readonly persisted = [];

  private _member!: Member;

  public get member(): Member {
    return this._member;
  }

  @Mutation
  setMember(member: Member): void {
    this._member = member;
  }
}
